const increaseTypelist = [
    { label: '近一周涨跌幅', value: 'weekIncrease' },
    { label: '近一月涨跌幅 ', value: 'monthIncrease' },
    { label: '近一年涨跌幅', value: 'yearIncrease' },
    { label: '年初至今涨跌幅', value: 'ytdIncrease' }
];

const increaseTypeOpt = new Map([
    [
        'cn',
        [
            { label: '近一周涨跌幅', value: 'weekIncrease' },
            { label: '近一月涨跌幅 ', value: 'monthIncrease' },
            { label: '近一年涨跌幅', value: 'yearIncrease' },
            { label: '年初至今涨跌幅', value: 'ytdIncrease' }
        ]
    ],
    [
        'hk',
        [
            { label: '近一週升幅', value: 'weekIncrease' },
            { label: '近一月升幅', value: 'monthIncrease' },
            { label: '近一年升幅 ', value: 'yearIncrease' },
            { label: '年初至今升幅', value: 'ytdIncrease' }
        ]
    ],
    [
        'us',
        [
            { label: '1W %CHG', value: 'weekIncrease' },
            { label: '1M %CHG', value: 'monthIncrease' },
            { label: '1Y %CHG', value: 'yearIncrease' },
            { label: 'YTD %CHG', value: 'ytdIncrease' }
        ]
    ]
]);
const increaseTypeMap = {}; // 编辑器展示的文案map

increaseTypelist.forEach(({ label, value }) => {
    increaseTypeMap[value] = label;
});

const btnConfig = {
    // 未添加自选
    noSubscribeBlueBtnImg:'https://fegostatic.futunn.com/images/2022041900000116bcdecee39c2.png',
    noSubscribeOrangeBtnImg:'https://fegostatic.futunn.com/images/202204190000011712215a2a3b3.png',
    noSubscribeRedBtnImg:'https://fegostatic.futunn.com/images/20220419000001180b2a0f1efc1.png',
    noSubscribeYellowBtnImg:'https://fegostatic.futunn.com/images/2022041900000119296f53ddf95.png',
    // 已添加自选
    hasSubscribeBlueBtnImg:'https://fegostatic.futunn.com/images/2022041900000120e7ce767c38c.png',
    hasSubscribeOrangeBtnImg:'https://fegostatic.futunn.com/images/20220419000001215909dfc1134.png',
    hasSubscribeRedBtnImg:'https://fegostatic.futunn.com/images/202204190000012240d29e73229.png',
    hasSubscribeYellowBtnImg:'https://fegostatic.futunn.com/images/202204190000012374e70fe2dd1.png',
};

const btnBgImgMap = new Map([
    // 未添加自选
    ['btn_type_watchlist_btn_blue', btnConfig.noSubscribeBlueBtnImg],
    ['btn_type_watchlist_btn_orange', btnConfig.noSubscribeOrangeBtnImg],
    ['btn_type_watchlist_btn_red', btnConfig.noSubscribeRedBtnImg],
    ['btn_type_watchlist_btn_yellow', btnConfig.noSubscribeYellowBtnImg],
    // 已添加自选
    ['has_sub_btn_type_watchlist_btn_blue', btnConfig.hasSubscribeBlueBtnImg],
    [
        'has_sub_btn_type_watchlist_btn_orange',
        btnConfig.hasSubscribeOrangeBtnImg
    ],
    ['has_sub_btn_type_watchlist_btn_red', btnConfig.hasSubscribeRedBtnImg],
    [
        'has_sub_btn_type_watchlist_btn_yellow',
        btnConfig.hasSubscribeYellowBtnImg
    ]
]);
// 数据展示类型
const showEnum = {
    'increase': 'increase',
    'finacial-indicator': 'finacial-indicator',
    'custom': 'custom',
};

const initHandlerMap = {
    'increase': 'initIncreaseData',
    'finacial-indicator': 'fetchFinacialIndicator',
    'custom': 'customData',
};

export default {
    increaseTypelist,
    increaseTypeMap,
    increaseTypeOpt,
    btnBgImgMap,
    showEnum,
    initHandlerMap
};
